<template>
  <div class="attachment-preview">
    <ImageAttachment
      v-if="attachment.type === 'img'"
      :attachment="attachment"
      :message-id="messageId"
      @image-click="(url, att) => $emit('imageClick', url, att)"
    />
    <VideoAttachment
      v-else-if="attachment.type === 'video'"
      :attachment="attachment"
      :message-id="messageId"
    />
    <AudioAttachment
      v-else-if="attachment.type === 'audio'"
      :attachment="attachment"
      :message-id="messageId"
    />
    <FileAttachment
      v-else-if="attachment.type === 'file'"
      :attachment="attachment"
      :message-id="messageId"
    />
    <LinkAttachment v-else-if="attachment.type === 'link'" :attachment="attachment" />
    <LinkedInPostAttachment
      v-else-if="attachment.type === 'linkedin_post'"
      :attachment="attachment"
    />
    <VideoMeetingAttachment
      v-else-if="attachment.type === 'video_meeting'"
      :attachment="attachment"
    />
  </div>
</template>

<script setup lang="ts">
import type { Attachment } from "@/dtos/Unipile.dto";
import ImageAttachment from "./attachments/ImageAttachment.vue";
import VideoAttachment from "./attachments/VideoAttachment.vue";
import AudioAttachment from "./attachments/AudioAttachment.vue";
import FileAttachment from "./attachments/FileAttachment.vue";
import LinkAttachment from "./attachments/LinkAttachment.vue";
import LinkedInPostAttachment from "./attachments/LinkedInPostAttachment.vue";
import VideoMeetingAttachment from "./attachments/VideoMeetingAttachment.vue";

interface Props {
  attachment: Attachment;
  messageId?: string;
}

defineProps<Props>();

defineEmits<{
  imageClick: [url: string, attachment: Attachment];
}>();
</script>

<style scoped>
.attachment-preview {
  margin-top: 0.5rem;
}
</style>
